import { onDocumentReady } from '@src/scripts/lib/event';
import { trackGtmEvent } from '@src/scripts/lib/gtm';
import globals from '@src/scripts/shared/globals';
import getPageType, { TPageType } from './getPageType';

const getId = ( pageType: TPageType ): string => {
	switch ( pageType ) {
		case 'Product Page':
			return globals.sfCode || globals.sfWebsiteCode;
		case 'Study Fulltime Page':
			return 'vz';
		case 'Study Allongside Page':
			return 'bb';
		case 'Study Distance Page':
			return 'bl';
		case 'Degree Type Page':
			return /master/.test( window.location.pathname ) ? 'mas' : 'bac';
		case 'Study Topics':
			return ( globals.themenweltKurz || '' ).toLowerCase();
		case 'Location Page':
			return globals.postTitle || '';
		case 'Blog Detail Page':
			return globals.postSlug;
		case 'Event registration Form': {
			const q = new URLSearchParams( window.location.search );

			return q.get( 'prefill' );
		}
	}

	return null;
};

onDocumentReady( () => {
	const pageType = ( globals.pageType as TPageType ) || getPageType();
	const id = getId( pageType );
	trackGtmEvent( 'sfisView', {
		virtualPath: location.pathname,
		pageType,
		language: 'de',
		id,
	} );
} );
